{
  "es": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Añadir un responsable",
        "bulk_remove": "Quitar",
        "confirm": "Marcar como completada",
        "delete": "Eliminar responsable",
        "document_add": "Añadir archivo",
        "document_delete": "Eliminar",
        "due_in_month": "En un mes",
        "due_in_two_weeks": "En dos semanas",
        "due_in_week": "En una semana",
        "due_remove": "Quitar fecha límite",
        "open": "Abrir",
        "reopen": "Reabrir",
        "selectAll": "Seleccionar las {total}",
        "send_and_notify": "Enviar y avisar",
        "set_due_date": "Establecer fecha límite",
        "set_status": "Establecer estado",
        "show_more": "Mostrar {count} tarea abierta más | Mostrar {count} tareas abiertas más",
        "show_more_completed": "Mostrar {count} tarea completada más | Mostrar {count} tareas completadas más",
        "unSelectAll": "Deseleccionar todo",
        "upload_files": "Subir {count} archivo | Subir {count} archivos"
      },
      "assignee_scopes": {
        "external": "Externo",
        "internal": "Interno"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Miembro del equipo",
        "partner": "Colaborador"
      },
      "attributes": {
        "assignee": "Responsable",
        "assignees": "Responsables",
        "comment": "Comentario",
        "created_at": "Creado",
        "document": "Documento",
        "due_date": "Fecha límite",
        "project": "Proyecto",
        "status": "Estado",
        "task": "Tarea",
        "unit": "Unidad"
      },
      "confirm": {
        "assignees_count": "{count} responsable | {count} responsables",
        "bulk_delete_accept": "Quitar",
        "bulk_delete_body": "Esto quita su tarea para esas unidades. La tarea en sí y los demás responsables conservan la suya.",
        "bulk_delete_body_project": "Esto quita su tarea. La tarea en sí y los demás responsables conservan la suya.",
        "bulk_delete_header": "¿Quitar {count} responsable? | ¿Quitar {count} responsables?",
        "complete_accept": "Completar todo",
        "complete_body": "Esto pone a {assignees} en {status}, también las tareas que el cliente aún no ha completado. Pasan a las tareas completadas de su lista.",
        "complete_header": "¿Marcar todo como completado?",
        "customer_tasks": "{count} tarea de cliente | {count} tareas de cliente",
        "customers_and_team": "{customers} y {team}",
        "delete_body": "Esto quita su tarea para esa unidad. Las demás unidades y responsables conservan la suya.",
        "delete_body_project": "Esto quita su tarea. Los demás responsables conservan la suya.",
        "delete_header": "¿Quitar a {name} de {unit}?",
        "delete_header_project": "¿Quitar a {name} de esta tarea?",
        "delete_sent_customers": "Esta ya se había enviado, así que también desaparece del portal de los clientes.",
        "delete_sent_team": "Esta ya se había enviado, así que también desaparece de la lista de {name}.",
        "document_delete_body": "El archivo también desaparece de los documentos de la unidad.",
        "document_delete_body_project": "El archivo también desaparece de los documentos del proyecto.",
        "document_delete_header": "¿Eliminar este archivo?",
        "draft_accept": "Poner todo en borrador",
        "draft_body": "Esto vuelve a poner a {assignees} en {status}. La tarea desaparece de la lista del cliente hasta que la vuelvas a enviar. Los correos ya enviados siguen enviados.",
        "draft_header": "¿Volver todo a borrador?",
        "send_body": "Esto pone {who} en {status}.",
        "send_customers": "Los clientes ven la tarea de inmediato en su portal y reciben un correo sobre ella.",
        "send_header": "¿Enviar esta tarea? | ¿Enviar estas tareas?",
        "send_permanent": "Puedes volver a ponerlas en Borrador más tarde, pero el aviso ya se habrá enviado.",
        "send_team": "Las personas del equipo ven la tarea en su panel y reciben un aviso.",
        "tasks_count": "{count} tarea | {count} tareas",
        "team_tasks": "{count} tarea de equipo | {count} tareas de equipo"
      },
      "deep_link": {
        "completed": "Esta tarea ya está completada.",
        "gone": "Esta tarea ya no está abierta."
      },
      "empty": {
        "filtered_description": "Ajusta tus filtros o bórralos para ver todas las asignaciones.",
        "filtered_title": "Ninguna asignación coincide con tus filtros",
        "none_title": "Sin asignaciones"
      },
      "filters": {
        "assignee_any": "Cualquier responsable",
        "clear_all": "Limpiar todos los filtros",
        "done": "Listo",
        "due_window_values": {
          "none": "Sin fecha límite",
          "overdue": "Atrasada",
          "set": "Con fecha límite"
        },
        "phase_any": "Cualquier fase",
        "show_only": "Mostrar solo",
        "show_only_values": {
          "customers": "Clientes",
          "mine": "Asignadas a mí",
          "team": "Equipo"
        },
        "unit_any": "Cualquier unidad"
      },
      "labels": {
        "add_assignee": "Añadir un responsable",
        "add_customers": "Añadir clientes",
        "already_assigned": "Esta tarea ya está añadida a esta unidad.",
        "already_assigned_project": "Esta tarea ya está añadida a este proyecto.",
        "assignees_subtitle": "Cada uno recibe su propia tarea, por unidad.",
        "assignees_title": "Quién debe hacerlo",
        "comment_add": "Añadir un comentario",
        "comment_earlier_round": "ronda anterior",
        "comment_placeholder": "¿Algo que debamos saber?",
        "comment_placeholder_upload": "¿Algo que debamos saber sobre estos documentos?",
        "comments_none": "El cliente no dejó ningún comentario.",
        "comments_title": "Comentarios sobre esta tarea",
        "completed": "Completadas",
        "confirm_message": "¿Seguro que quieres marcar esta tarea como completada?",
        "customers": "Clientes",
        "documents_none": "Todavía no se ha subido nada.",
        "documents_title": "Archivos de esta tarea",
        "earlier": "+{count} anteriores",
        "my_tasks": "Mis tareas",
        "no_assignees": "Todavía no hay responsables.",
        "no_assignments": "Las tareas que se te asignen aparecen aquí.",
        "no_assignments_task": "Todavía no hay asignaciones para esta tarea.",
        "previous_upload": "Subida anterior",
        "required": "Este campo es obligatorio",
        "section_completed": "Completadas",
        "section_open": "Abiertas",
        "selectOne": "Seleccione al menos una tarea.",
        "select_task": "Selecciona una tarea",
        "selected": "{selected} seleccionada | {selected} seleccionadas",
        "set_status_for": "Establecer el estado de {name}",
        "status_hint_assignees": "la persona asignada | las personas asignadas",
        "status_hint_customer": "el cliente",
        "status_hint_sent": "las personas a las que se envió",
        "superseded": "Sustituido",
        "totalSelected": "Las {total} seleccionadas",
        "upload_hint": "Sube el documento o los documentos solicitados para completar esta tarea."
      },
      "status_hints": {
        "completed": "La tarea está completada. Sigue visible para {who}, en {completed}.",
        "draft": "Aún no es visible para {who}. Pon la tarea en {open} para compartirla.",
        "requested": "Visible para {who}. La tarea aún debe completarse."
      },
      "statuses": {
        "completed": "Completada",
        "draft": "Borrador",
        "requested": "Abierta"
      },
      "toasts": {
        "bulk_delete": "Tareas quitadas",
        "bulk_update": "Tareas actualizadas",
        "completed": "Tarea completada",
        "create": "Tarea creada",
        "delete": "Responsable eliminado",
        "document_added": "Archivo añadido",
        "document_deleted": "Archivo eliminado",
        "reopened": "Tarea reabierta",
        "update": "Tarea actualizada"
      }
    }
  }
}
